import { ApartmentOutlined, DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { useTranslation } from 'react-i18next'; // Ekleyin
import i18n from "../../../i18n";
import { ICampusFilter } from "../../../interfaces/ICampusData";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";



const CampusManagement: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const loader = new StateLoader();
  const [campusData, setCampusData] = useState<ICampusFilter>({});
  const userInfo: IAuthentication = loader.loadAuthState();
  const dataGridRef = useRef<any>(null);
  const toast = useRef<any>(null);

  const pageData: IPageData = {
    title: t('campusManagement'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);



  const isAltisAdmin = userInfo?.role === UserRole.AltisAdmin;

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true,
    }] : []),
    { title: t('campus'), isSorting: true, key: 'campusName', placeHolder: t('campus'), align: 'center', headerAlign: 'center' },
    //{ title: t('barcode'), key: 'barcode', placeHolder: t('barcode'), inputType: "input" },
    { title: t('campus_count'), hideColumnMenu: true, isSorting: true, key: 'campusCount', placeHolder: t('campus_count'), align: 'center', headerAlign: 'center' },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      isSorting: false,
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: 10,  marginLeft: isAltisAdmin ? 160 : 175, }}>
          <Space size={10}>
            <Popconfirm
              title={<div>{t('are_you_sure_campus')} <br /></div>}
              onConfirm={() => DeleteCampus(record.campusId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={(e) => { e.stopPropagation(); }}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                >
                </Button>
              </Tooltip>
            </Popconfirm>
            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                onClick={() => window.location.replace('/admin/update-campus/' + record.campusId)}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    }
  ];

  const CampusFilter = (e?) => {
    const filters = e?.filters;
    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      campusName: filters?.campusName,
      companyName: filters?.companyName,
    };

    HTTPService.POST(`/Campus/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setCampusData(response.data);
      } else if (response.status === 450) {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const DeleteCampus = (Id) => {
    HTTPService.DELETE(`/Campus/deleteCampus?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData()
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
        else if (response.status === 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            hidden={userInfo.role === UserRole.Sayman}
            icon={<HomeOutlined style={{ fontSize: 24 }} />}
            onClick={() => window.location.replace('/admin/add-campus')}
          >
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_new_campus')}
            </span>
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid ref={dataGridRef} data={campusData?.data} total={campusData?.count} columns={columns} onChange={CampusFilter} filterMode="server" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CampusManagement;
